<template>
  <el-row :gutter="20">
    <el-col :span="12">
      <data-show :label="paymentObj.payMode === 'ALIPAY' ? '收款账户：':'银行账号：'">
        <page-encrypt-icon
          :value.sync="paymentObj[`bankCardNumber-new`]"
          :encryptValue="paymentObj.bankCardNumber"
        />
      </data-show>
    </el-col>
    <template v-if="paymentObj.payMode === 'BANK_CARD_PAY'">
      <el-col :span="12">
        <data-show label="收款银行：">
          {{paymentObj.bankName || '-'}}
        </data-show>
      </el-col>
    </template>
    <el-col :span="12">
      <data-show :label="paymentObj.payMode === 'ALIPAY' ? '收款户名：': '账户名称：'">
        {{paymentObj.bankAccountName || '-'}}
      </data-show>
    </el-col>
    <template v-if="paymentObj.payMode === 'BANK_CARD_PAY'">
      <el-col :span="12">
        <data-show label="支行名称：">
          {{paymentObj.bankBranchInfo || '-'}}
        </data-show>
      </el-col>
    </template>
    <el-col :span="12">
      <data-show label="账户类型：">
        {{paymentObj.bankAccountTypeDesc || '-'}}
      </data-show>
    </el-col>
  </el-row>
</template>
<script>

export default {
  props: {
    paymentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
